import React from 'react'
import { Field } from 'formular'
import { useCallback, useForceUpdate, useEffect } from 'sb-hooks'

import CheckboxView, { CheckboxViewProps } from './CheckboxView/CheckboxView'


export type FormularCheckboxProps = Omit<CheckboxViewProps, 'value'> & {
  field: Field<any>
  onChange?: (value: boolean) => void
}

const FormularCheckbox: React.FunctionComponent<FormularCheckboxProps> = (props) => {
  const { children, className, field, label, labelProps = {}, dataTestId, onChange } = props

  const isChecked = Boolean(field.state.value)
  const forceUpdate = useForceUpdate()

  useEffect(() => {
    const handleChange = (newValue) => {
      forceUpdate()

      if (typeof onChange === 'function') {
        onChange(newValue)
      }
    }

    field.on('change', handleChange)
    field.on('unset', handleChange)
    field.on('validate', forceUpdate)

    return () => {
      field.off('change', handleChange)
      field.off('unset', handleChange)
      field.off('validate', forceUpdate)
    }
  }, [ field, onChange ]) // eslint-disable-line react-hooks/exhaustive-deps

  const handleChange = useCallback((event) => {
    field.set(event.target.checked)
  }, [ field ])

  return (
    <CheckboxView
      className={className}
      label={label}
      labelProps={labelProps}
      value={isChecked}
      onChange={handleChange}
      dataTestId={dataTestId}
    >
      {children}
    </CheckboxView>
  )
}


export default FormularCheckbox
